import { liveUpdateConnection } from '../liveConnection/LiveUpdateConnection';
import { checkHashStore } from '../../store/checkHashStore';
import { liveUpdateStore } from '../../store/liveUpdateStore';

class LiveUpdateService {
  handleLiveSpinUpdate(data) {
    liveUpdateStore.updateLiveSpinUpdate(data);
  }

  handleGetAllLiveBets(data) {
    liveUpdateStore.setAllGamesLiveSpins([...data].reverse());
  }

  checkResultHash(params) {
    liveUpdateConnection.checkResultHash(params);
  }

  handleCheckResultHashResult(hash) {
    checkHashStore.setCalculateSaltAndKey({ hash });
  }
}

export const liveUpdateService = new LiveUpdateService();
